var map = {
	"./en": [
		"IHnZ",
		1
	],
	"./en.json": [
		"IHnZ",
		1
	],
	"./zh": [
		"VmmV",
		0
	],
	"./zh.json": [
		"VmmV",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "v4t/";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./public/locale lazy ^\.\/.*$
// module id = v4t/
// module chunks = 2 3 4 5 6